import React, { Component } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import de from 'date-fns/locale/de';
import { translate } from "react-i18next";
import { FormControl, Row, Col, Button, Form } from 'react-bootstrap';
import {validateDate} from '../../backend/UIUtils'


registerLocale('de', de);

function emptyEventDate(eventId) {
    if (eventId > 0) {
        return { eventId: eventId, startDate: new Date(), endDate: new Date(), comment: '' };
    } else {
        return { startDate: new Date(), endDate: new Date(), comment: '' };
    }
}

class DateChooseAdd extends Component {

    constructor(props) {
        super(props);

        this.onDateChooseAdd = this.onDateChooseAdd.bind(this);
        this.onEventStartDateChange = this.onEventStartDateChange.bind(this);
        this.onEventEndDateChange = this.onEventEndDateChange.bind(this);
        this.onEventInputChange = this.onEventInputChange.bind(this);
        this.state = {
            eventDate: emptyEventDate(this.props.eventId ? this.props.eventId : 0),
            dirty: false
        }
    }

   


    onDateChooseAdd() {
        this.props.onAdd(this.state.eventDate);
        this.setState({
            eventDate: emptyEventDate(this.props.eventId ? this.props.eventId : 0),
            dirty: false
        })
    }

    onEventStartDateChange(choosed) {
        const { eventDate } = this.state;

        const newEventDate = {
            ...eventDate,
            startDate: choosed !== null ? choosed.getTime() : '',
            endDate: choosed !== null ? choosed.getTime() : ''
        };

        this.setState({
            eventDate: newEventDate,
            dirty: true
        });
    }

    onEventEndDateChange(choosed) {
        const { eventDate } = this.state;

        const newEventDate = {
            ...eventDate,
            endDate: choosed !== null ? choosed.getTime() : ''
        };

        this.setState({
            eventDate: newEventDate,
            dirty: true
        });
    }



    onEventInputChange(obj) {
        const { name: fieldName, value: fieldValue } = obj.target;
        const { eventDate } = this.state;

        const newEventDate = {
            ...eventDate,
            [fieldName]: fieldValue
        };
        this.setState({
            eventDate: newEventDate,
            dirty: true
        });
    }


    render() {
        const { t } = this.props;
        const { startDate, endDate, comment } = this.state.eventDate;

        return (
            <div className="  p-2 mt-2">
              
                <Row >
                   <Col lg={6}>
                   <Form.Group lg={6}>
                       <Form.Label >{t("eventStart")}</Form.Label>
                       <DatePicker selected={startDate} 
                                onChange={this.onEventStartDateChange}
                                placeholderText={t("Startdatum")}
                                minDate={new Date()}
                                showTimeSelect
                                timeFormat="HH:mm"
                                dateFormat="Pp"
                                locale="de"
                                className="form-control"
                            />
                    </Form.Group>
                   </Col>
                   <Col lg={6}>
                   
                   
                        <Form.Group >
                            <Form.Label >{t("eventEnd")}</Form.Label>
                            <DatePicker selected={endDate}
                                onChange={this.onEventEndDateChange}
                                placeholderText={t("endDatum")}
                                minDate={new Date()}
                                showTimeSelect
                                timeFormat="HH:mm"
                                dateFormat="Pp"
                                locale="de"
                                className="form-control"
                            />
                        </Form.Group>
                        </Col>
                      
                  
                    </Row>
                    
                    <Row className="mt-3">
                    <Col lg={12} >
                        <FormControl name="comment" as="textarea" rows="5" placeholder={t("kommentar")} value={comment} onChange={this.onEventInputChange} />
                    </Col>
                    </Row>
                    <Row className="mt-3">
                    
                    <Col >
                    <Button variant="success " onClick={this.onDateChooseAdd} className="float-right" disabled={!validateDate(this.state.eventDate.startDate, this.state.eventDate.endDate)}>{t("Terminhinzufuegen")}</Button>

                    <Button variant="success " onClick={this.props.onClose} className="float-right mr-1 ml-1" >{t("close")}</Button>
                    </Col>
                </Row>
               
            </div>

        );
    }
}

export default translate("translations")(DateChooseAdd);
